import { setRangeMin } from './helpers';

export const setMinCeilingHeight = setRangeMin('ceiling_height');
